import { useRouter } from "vue-router";


export function pageNotFoundUse() {

    const router = useRouter();


    async function goToHome() {
        await router.push("/home");
        window.scrollTo(0, 0);
    }


    return {
        goToHome
    };
}
